export const actions = {
    SET_GLOBAL_FAIL: 'SET_GLOBAL_FAIL',
    SET_REDIRECT_TRUE: 'SET_REDIRECT_TRUE',
    SET_REDIRECT_FALSE: 'SET_REDIRECT_FALSE',
  };
  
  const initialState = {
    redirect: false
  };
  
  export default (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
      case actions.SET_REDIRECT_TRUE: {
       return {
         redirect: true
       }
      }
      case actions.SET_REDIRECT_FALSE: {
        return {
          redirect: false
        }
      }
      default:
        return state;
    }
  };